import React from 'react';
import { Form, Checkbox } from 'antd'

class AppointmentReminder extends React.Component {
  render() {
    return (
      <Form name="appointment-reminder">
        <div className="fluid-field field-action action-group">
          <button className="btn-action">
            Send Email
          </button>
          <button className="btn-action">
            Send SMS
          </button>
          <button className="btn-action">
            View History
          </button>
          <button className="btn-action">
            Print Mail
          </button>
        </div>
        <Form.Item label="Claimant" className="fluid-field">
          <Checkbox.Group>
            <Checkbox>Exclude SMS</Checkbox>
            <Checkbox>Exclude Email</Checkbox>
          </Checkbox.Group>
        </Form.Item>
        <Form.Item label="Case Manager" className="fluid-field">
          <Checkbox.Group>
            <Checkbox>Exclude SMS</Checkbox>
            <Checkbox>Exclude Email</Checkbox>
          </Checkbox.Group>
        </Form.Item>
        <Form.Item label="Doctor" className="fluid-field">
          <Checkbox.Group>
            <Checkbox>Exclude SMS</Checkbox>
            <Checkbox>Exclude Email</Checkbox>
          </Checkbox.Group>
        </Form.Item>
      </Form>
    )
  }
}

export default AppointmentReminder